import { ReleaseNote } from '@src/main/modules/parameters/domain/release-notes/release-note.interface';

export interface ReleaseNoteEntity {
  releaseNoteId?: string;
  description: string;
  version: string;
}

export function toReleaseNote(entity: ReleaseNoteEntity): ReleaseNote {
  return {
    releaseNoteId: entity.releaseNoteId,
    description: entity.description,
    version: entity.version,
  };
}

export function fromReleaseNote(model: ReleaseNote): ReleaseNoteEntity {
  return {
    releaseNoteId: model.releaseNoteId,
    description: model.description,
    version: model.version,
  };
}
